import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAthleteAuthContext } from "../login/useAthleteAuthContext";

export const AthleteHeader = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { athlete } = useAthleteAuthContext();

  // --- Highlight Logic for AMAX COACHED ---
  const coachedSpeedActive =
    location.pathname.startsWith("/athlete/coached/warmup-routine-phases") ||
    location.pathname.startsWith("/athlete/coached/warmup-routine-phase-exercises") ||
    location.pathname.startsWith("/athlete/coached/speed-workout");
        location.pathname.startsWith("/athlete/coached/speed-workout");

  const coachedStrengthActive =
    location.pathname.startsWith("/athlete/coached/strength-workout");

  return (
    <div className="relative pt-2 pb-2">
      <div className="w-full max-w-screen-xl mx-auto flex flex-row justify-between items-center gap-10 px-5">
        <div className="relative w-full flex flex-row gap-[30px] border-b border-black/30">

          {/* ---------- NON-AMAX COACHED ---------- */}
          {athlete.account_type !== "AMAX COACHED" && (
            <>
              {/* Speed */}
              <Link
                to="/athlete/free-warmup-routine/phase"
                className={`relative -mb-px px-2 h-8 flex items-center border-b-2 border-b-transparent hover:border-yellow-600 ${
                  location.pathname.startsWith('/athlete/free-warmup-routine') ||
                  location.pathname.startsWith('/athlete/free-speed-workout')
                    ? 'font-bold  !border-yellow-600 text-black'
                    : 'font-medium text-lightSmock'
                }`}
              >
                Speed
              </Link>

              {/* Strength */}
              <Link
                to="/athlete/free-strength-workout"
                className={`relative -mb-px px-2 h-8 flex items-center border-b-2 border-b-transparent hover:border-yellow-600 ${
                  location.pathname.startsWith('/athlete/free-strength-workout')
                    ? 'font-bold  !border-yellow-600 text-black'
                    : 'font-medium text-lightSmock'
                }`}
              >
                Strength
              </Link>
            </>
          )}

          {/* ---------- AMAX COACHED ---------- */}
          {athlete.account_type === "AMAX COACHED" && (
            <>
              {/* SPEED (single tab but inner pages tracked) */}
              <div
                className={`relative -mb-px px-2 h-8 flex items-center border-b-2 border-b-transparent hover:border-yellow-600 ${
                  coachedSpeedActive
                    ? "font-bold  !border-yellow-600 text-black"
                    : "font-medium text-lightSmock"
                }`}
                onClick={() => navigate("/athlete/coached/warmup-routine-phases")}
              >
                Speed
              </div>

              {/* STRENGTH */}
              <div
                className={`relative -mb-px px-2 h-8 flex items-center border-b-2 border-b-transparent hover:border-yellow-600 ${
                  coachedStrengthActive
                    ? "font-bold  !border-yellow-600 text-black"
                    : "font-medium text-lightSmock"
                }`}
                onClick={() => navigate("/athlete/coached/strength-workout")}
              >
                Strength
              </div>
            </>
          )}

        </div>
      </div>
    </div>
  );
};
